export default __webpack_public_path__ + "static/media/Women-10.946bc003.svg";